export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DEFAULT_VALUES = {
  PlaceName: '',
  PlaceORI: '',
  PlaceDepartmentID: '',
  PlaceType: '',
  IsDestination: false,
  ptsAddressID: null,
  IsPrimary: false,
  ContactMethod: '',
  ContactMethodType: '',
  Info: '',
  IsDefault: true,
  Notes: '',
};

export const PLACE_TAB_KEYS = {
  EDIT: 'edit',
  ADDRESS: 'address',
  CONTACT: 'contact',
  EMPLOYEES: 'employees',
  SOPS: 'sops',
  VEHICLES: 'vehicles',
};

export const PLACE_TABS = [
  { key: PLACE_TAB_KEYS.EDIT, label: 'Place' },
  { key: PLACE_TAB_KEYS.ADDRESS, label: 'Address' },
  { key: PLACE_TAB_KEYS.CONTACT, label: 'Contact' },
  { key: PLACE_TAB_KEYS.EMPLOYEES, label: 'Employees' },
  { key: PLACE_TAB_KEYS.SOPS, label: 'SOPs' },
  { key: PLACE_TAB_KEYS.VEHICLES, label: 'Vehicle Registrations' },
];
